import { ChangeDetectionStrategy, Component, signal, viewChild } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { WorkingDays } from '@pedix-workspace/utils';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconInfoComponent } from '@pedix-workspace/angular-ui-icons';
import { WorkingHoursMessageDetailsComponent } from '../working-hours-message-details/working-hours-message-details.component';

@Component({
  selector: 'pxw-working-hours-message-dialog',
  templateUrl: './working-hours-message-dialog.component.html',
  styleUrls: ['./working-hours-message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslocoDirective,
    ModalDialogComponent,
    WorkingHoursMessageDetailsComponent,
    IconInfoComponent,
  ],
})
export class WorkingHoursMessageDialogComponent {
  readonly workingDays = signal<WorkingDays | null>(null);

  readonly modalDialog = viewChild.required(ModalDialogComponent);

  open(workingDays: WorkingDays | null) {
    this.workingDays.set(workingDays);

    return this.modalDialog()
      .open()
      .catch(() => {});
  }
}
